export const getMenuItems = () => [
  {
    key: 'dashboard',
    title: 'Dashboard',
    path: '/dashboard',
    icon: 'q4i-dashboard-2pt',
    section: 'root'
  },
  {
    key: 'contacts',
    title: 'Contacts',
    path: '/contact',
    pattern: [
      '/contact',
      '/contact/:id'
    ],
    icon: 'q4i-contact-2pt',
    section: 'root'
  },
  {
    key: 'changeRequests',
    title: 'Change Requests',
    path: '/changeRequest',
    icon: 'q4i-stage-2pt',
    section: 'root'
  },
  {
    key: 'custom',
    title: 'Custom Contacts',
    path: '/custom/security',
    pattern: [
      '/custom/security',
      '/custom/security/:id'
    ],
    icon: 'q4i-custom-2pt',
    section: 'root'
  }
]
